import React from 'react';
import styled, { css } from 'styled-components';
import { ReactComponent as Circle } from 'assets/img/icons/circle.svg';

type Props = {
  text?: string;
  variant: 'yellow' | 'purple';
};

export const Background = styled.div<Props>`
  background: ${({ variant }) => variant};
  font-size: 14px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  width: 166px;
  gap: 8px;

  ${({ variant }) =>
    variant === 'yellow' &&
    css`
      background-color: #fdecce;
      color: #623f04;
      > svg {
        circle:first-child {
          fill: #fbd89d;
        }
        circle:last-child {
          fill: #f59e0b;
        }
      }
    `}
  ${({ variant }) =>
    variant === 'purple' &&
    css`
      background-color: #e8defd;
      color: #1c1231;
      > svg {
        circle:first-child {
          fill: #d1befb;
        }
        circle:last-child {
          fill: #8b5cf6;
        }
      }
    `}
`;

const Status = ({ text, variant }: Props) => (
  <Background variant={variant}>
    <Circle />
    <span>{text}</span>
  </Background>
);

export default Status;
